import { z } from 'zod';
import type { ApiSchemaClass, ApiSchemaDefinition } from './types';
import {
  billingAddCardSessionResponseSchema,
  billingUpdateCardSessionResponseSchema,
  statusSuccessResponseSchema,
} from './common-responses';

const topUpConfigSchema = z.object({
  amount: z.number(),
  threshold: z.number(),
});

export const billingAddCreditsBodyV20260601Schema = z.object({
  amount: z.number(),
});

export type BillingAddCreditsBody = z.infer<
  typeof billingAddCreditsBodyV20260601Schema
>;

export const billingTopUpBodyV20260601Schema = z.object({
  config: topUpConfigSchema.nullable(),
});

export type BillingTopUpBody = z.infer<typeof billingTopUpBodyV20260601Schema>;

export const billingSessionReturnUrlBodyV20260601Schema = z.object({
  returnUrl: z.string(),
});

export type BillingSessionReturnUrlBody = z.infer<
  typeof billingSessionReturnUrlBodyV20260601Schema
>;

export class BillingAddCreditsV20260601Schema implements ApiSchemaDefinition {
  static readonly version = 'billing-add-credits-2026-06-01' as const;

  readonly name = BillingAddCreditsV20260601Schema.version;
  readonly schema = billingAddCreditsBodyV20260601Schema;
  readonly response = statusSuccessResponseSchema;
}

export class BillingTopUpV20260601Schema implements ApiSchemaDefinition {
  static readonly version = 'billing-top-up-2026-06-01' as const;

  readonly name = BillingTopUpV20260601Schema.version;
  readonly schema = billingTopUpBodyV20260601Schema;
  readonly response = statusSuccessResponseSchema;
}

export class BillingAddCardSessionV20260601Schema
  implements ApiSchemaDefinition
{
  static readonly version = 'billing-add-card-session-2026-06-01' as const;

  readonly name = BillingAddCardSessionV20260601Schema.version;
  readonly schema = billingSessionReturnUrlBodyV20260601Schema;
  readonly response = billingAddCardSessionResponseSchema;
}

export class BillingUpdateCardSessionV20260601Schema
  implements ApiSchemaDefinition
{
  static readonly version = 'billing-update-card-session-2026-06-01' as const;

  readonly name = BillingUpdateCardSessionV20260601Schema.version;
  readonly schema = billingSessionReturnUrlBodyV20260601Schema;
  readonly response = billingUpdateCardSessionResponseSchema;
}

export const BILLING_API_SCHEMAS = [
  BillingAddCreditsV20260601Schema,
  BillingTopUpV20260601Schema,
  BillingAddCardSessionV20260601Schema,
  BillingUpdateCardSessionV20260601Schema,
] as const satisfies readonly ApiSchemaClass[];
